/**
 * Unit Type Service — admin-managed product unit types (BMF-87).
 *
 * GET    /api/unit-types          - active unit types (for the product dropdown)
 * GET    /api/unit-types/manage   - all unit types + product usage (admin)
 * POST   /api/unit-types          - create a custom unit type (admin)
 * PATCH  /api/unit-types/:id      - rename / activate-deactivate / reorder (admin)
 * DELETE /api/unit-types/:id      - delete an unused custom unit type (admin)
 */

import api from './api';

// Single source of truth for the endpoint path — change it here if the API moves.
const BASE = '/unit-types';

const unitTypeService = {
  /** Active unit types, in admin-defined order — used to build the product form dropdown. */
  getActive: async () => {
    const response = await api.get(BASE);
    return response.data;
  },

  /** All unit types (active + inactive) with per-type product usage — for the management modal. */
  getAll: async () => {
    const response = await api.get(`${BASE}/manage`);
    return response.data;
  },

  /** Create a new custom unit type. */
  create: async (label) => {
    const response = await api.post(BASE, { label });
    return response.data;
  },

  /** Update a unit type: { label?, isActive?, sortOrder? }. */
  update: async (id, updates) => {
    const response = await api.patch(`${BASE}/${id}`, updates);
    return response.data;
  },

  /** Delete an unused custom unit type. */
  remove: async (id) => {
    const response = await api.delete(`${BASE}/${id}`);
    return response.data;
  },
};

export default unitTypeService;
